package com.hyperether.goodjob.scenes.contacts.components

import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.material.Divider
import androidx.compose.material.MaterialTheme
import androidx.compose.material.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerIcon
import androidx.compose.ui.input.pointer.pointerHoverIcon
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.navigation.NavHostController
import com.hyperether.goodjob.models.Site
import com.hyperether.goodjob.resources.Res
import com.hyperether.goodjob.resources.edit
import com.hyperether.goodjob.scenes.components.clickableWithPointer
import com.hyperether.goodjob.scenes.components.disableMouseDragScrollOnWeb
import com.hyperether.goodjob.scenes.components.verticalScrollbar
import com.hyperether.goodjob.util.toScaleDp
import com.hyperether.goodjob.util.toScaleSp
import org.jetbrains.compose.resources.painterResource

@Composable
fun SiteListWeb(
    sites: List<Site>,
    navHostController: NavHostController,
    isEmployee: Boolean,
    onEditSiteClick: (String?) -> Unit
) {
    val listState = rememberLazyListState()
    LazyColumn(
        state = listState,
        modifier = Modifier
            .fillMaxSize()
            .verticalScrollbar(listState)
            .disableMouseDragScrollOnWeb(),
        contentPadding = PaddingValues(vertical = 16.toScaleDp())
    ) {
        items(sites) { rowItem ->
            SiteListRow(
                rowItem = rowItem,
                isEmployee = isEmployee,
                onEditSiteClick = { onEditSiteClick(rowItem.id) }
            )
        }
    }
}

@Composable
fun SiteListRow(
    rowItem: Site,
    isEmployee: Boolean,
    onEditSiteClick: (String?) -> Unit
) {
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .height(58.toScaleDp())
            .padding(horizontal = 22.toScaleDp())
            .clip(MaterialTheme.shapes.medium)
            .pointerHoverIcon(PointerIcon.Hand),
        verticalArrangement = Arrangement.Center
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            modifier = Modifier.padding(horizontal = 24.toScaleDp())
        ) {

            Row(
                verticalAlignment = Alignment.CenterVertically,
                horizontalArrangement = Arrangement.Start,
                modifier = Modifier.weight(1.4f)
            ) {
//                Checkbox(
//                    checked = false,
//                    onCheckedChange = { }
//                )
                Column(
                    modifier = Modifier
                        .weight(1.4f)
                ) {
                    Text(
                        text = rowItem.siteName ?: " ",
                        color = Color(0xFF34618E),
                        fontSize = 16.toScaleSp(),
                        fontWeight = FontWeight.Bold,
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.padding(end = 4.toScaleDp())
                    )
                    Text(
                        text = rowItem.personName ?: " ",
                        color = Color(0xFF323232),
                        fontSize = 16.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis,
                        modifier = Modifier.padding(end = 4.toScaleDp())
                    )
                }
            }
            Text(
                text = rowItem.addressObject?.address ?: " ",
                color = Color(0xFF323232),
                fontSize = 14.toScaleSp(),
                modifier = Modifier
                    .weight(1.5f).padding(end = 4.toScaleDp()),
                maxLines = 1,
                overflow = TextOverflow.Ellipsis
            )
            Row(
                modifier = Modifier
                    .weight(1.5f),
                horizontalArrangement = Arrangement.SpaceBetween,
                verticalAlignment = Alignment.CenterVertically
            ) {
                Column(
                    modifier = Modifier.weight(1f)
                ) {
                    Text(
                        text = rowItem.personPhone ?: " ",
                        color = Color(0xFF323232),
                        fontSize = 14.toScaleSp(),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                    Text(
                        text = rowItem.personEmail ?: " ",
                        fontSize = 14.toScaleSp(),
                        modifier = Modifier
                            .weight(1.5f),
                        maxLines = 1,
                        overflow = TextOverflow.Ellipsis
                    )
                }
                if (!isEmployee) {
                    Image(
                        painter = painterResource(Res.drawable.edit),
                        contentDescription = "Edit button",
                        modifier = Modifier
                            .clickableWithPointer {
                            onEditSiteClick(rowItem.id)
                        }
                    )
                }
            }
        }
        Divider(
            modifier = Modifier.fillMaxWidth().height(1.toScaleDp())
                .background(Color.LightGray.copy(alpha = 0.1f))
        )
    }
}
